// removed by extract-text-webpack-plugin
module.exports = {"UserInfo":"avatar__UserInfo__ef7pG","BigAvatar":"avatar__BigAvatar__3-4Rr","Avatar":"avatar__Avatar__TUTCt","AvatarContainer":"avatar__AvatarContainer__2vDST","AvatarOverlay":"avatar__AvatarOverlay__2Iq0R","CameraIcon":"avatar__CameraIcon__2dYlm","Username":"avatar__Username__-XPeg"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/Avatar/avatar.css
// module id = 877
// module chunks = 2